import { Ability } from '@casl/ability'
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import { initialAbility } from './config'

Vue.use(VueCookies)
const userData = Vue.$cookies.get('userData')
const existingAbility = userData ? userData.ability : null
export default new Ability(existingAbility || initialAbility)
